module.exports = __webpack_public_path__ + "travelocity-src-icon.png?cc3c77700d8a51a8b44820749f526476";